import React from "react";
import chip from "../../../assets/images/chip.png";
import visa from "../../../assets/images/visa.png";
import map from "../../../assets/images/map.png";
import pattern from "../../../assets/images/pattern.png";
import master from "../../../assets/images/master.png";

const DebitCard = ({ name, card_number, ccv, cardType, createdAt, margin }) => {
  const cardNumbersToString =
    card_number == null ? "" : String(card_number).replace(/\s/g, "");

  // === Your original 4 + setup ===
  const firstNumbers = 4 + cardNumbersToString.slice(0, 3);
  const secondNumbers = cardNumbersToString.slice(3, 7);
  const thirdNumbers = cardNumbersToString.slice(7, 11);
  const fourthNumbers = cardNumbersToString.slice(11, 15);

  // Expiry date
  const dateObj = new Date(createdAt);
  const isValidDate = !isNaN(dateObj.getTime());
  const year = isValidDate ? dateObj.getFullYear().toString() : "";
  const expiryYear = year.slice(2, 4);
  const month = isValidDate ? dateObj.getMonth() + 1 : 9;

  // Dynamic gradient (same as before)
  const gradientColor =
    cardNumbersToString[0] % 2 === 1 ? "black" : "#ff2c7d";

  return (
    <div style={{ marginTop: margin }} className="card">
      <div className="card_inner">
        {/* FRONT */}
        <div
          style={{
            backgroundImage: `linear-gradient(45deg, #0045c7, ${gradientColor})`,
          }}
          className="card_front"
        >
          <img src={map} alt="map" className="map_image" />

          <div className="row">
            <img src={chip} alt="chip" />
            {cardType === "Visa" ? (
              <img src={visa} alt="visa" className="visa" />
            ) : (
              <img src={master} alt="mastercard" className="visa" />
            )}
          </div>

          <div className="row card_number_wrappepr">
            <p>{firstNumbers || "••••"}</p>
            <p>{secondNumbers || "••••"}</p>
            <p>{thirdNumbers || "••••"}</p>
            <p>{fourthNumbers || "••••"}</p>
          </div>

          <div className="row card_details_sect">
            <p>CARD HOLDER</p>
            <p>VALID TILL</p>
          </div>

          <div className="row card_name_sect">
            <p>{name || "CARD HOLDER"}</p>
            <p>
              {month} / {isValidDate ? Number(expiryYear) + 4 : 25}
            </p>
          </div>
        </div>

        {/* BACK */}
        <div
          style={{
            backgroundImage: `linear-gradient(45deg, #0045c7, ${gradientColor})`,
          }}
          className="card_back"
        >
          <img src={map} alt="map" className="map_image" />
          <div className="bar_code"></div>

          <div className="row card_cvv">
            <div>
              <img src={pattern} alt="pattern" />
            </div>
            <p>{ccv || "•••"}</p>
          </div>

          <div className="row card_text">
            <p>
              With our International Debit Card, Spend easily and securely
              anywhere, at any time.
            </p>
          </div>

          <div className="row signature">
            <p>CUSTOMER SIGNATURE</p>
            {cardType === "Visa" && <img src={visa} alt="visa" />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DebitCard;
